import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { WalletTabProvider } from './context/WalletTabContext';
import { ToastProvider } from './contexts/ToastContext';

import Index from './pages/Index';
import Home from './pages/Home';
import Advanced from './pages/Advanced';
import Create from './pages/Create';
import Mywallet from './pages/Mywallet';
import Game from './pages/Game';
import GameTest from './pages/GameTest';
import Luckdraw from './pages/Luckdraw';
import TokenDistributor from './pages/TokenDistributor';




declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

function App() {
  return (
    <ToastProvider>
      <WalletTabProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Index />} />
            {/* <Route path="/index" element={<Home />} /> */}
            <Route path="/advanced" element={<Advanced />} />
            <Route path="/create" element={<Create />} />
            <Route path='/mywallet' element={<Mywallet />} />
            <Route path='/game' element={<Game />} />
            <Route path='/gametest' element={<GameTest />} />
            <Route path='/luckdraw' element={<Luckdraw />} />
            <Route path='/facai' element={<TokenDistributor />} />
            
          </Routes>
        </Router>
      </WalletTabProvider>
    </ToastProvider>
  );
}

export default App;
